module.exports = __webpack_public_path__ + "media/images/top/seminars/template/image03-4e69de10d13c09bd734f777983a4027f.jpeg";